export enum OrderTypeTrackingProperty {
	limit_order = "limit_order",
	market_order = "market_order",
	margin_order = "margin_order",
	margin_limit_order = "margin_limit_order"
}

export enum MarginPositionType {
	open = "open",
	close = "close",
	increase = "increase",
	decrease = "decrease"
}

export enum MarginLeverageDirection {
	long = "long",
	short = "short"
}

export enum TradeTypeTrackingProperty {
	buy = "buy",
	sell = "sell",
	swap = "swap",
	saving_plans = "saving_plans"
}

export enum TradeTrackingName {
	TaxDeclarationViewed = "Tax Declaration Viewed",
	FiatSelectionViewed = "Fiat Selection Viewed",
	AssetSelectionViewed = "Asset Selection Viewed",
	AssetSelectionAssetTapped = "Asset Selection Asset Tapped",
	AssetSelectionClosed = "Asset Selection Closed",
	Assetwalletselectionviewed = "Asset wallet selection viewed",
	AssetWalletTapped = "Asset Wallet Tapped",
	AssetWalletSelectionClosed = "Asset Wallet Selection Closed",
	TradeAmountScreenViewed = "Trade Amount Screen Viewed",
	TradeAmountScreenUnitsTapped = "Trade Amount Screen Units Tapped",
	TradeAmountScreenUnitsUpdated = "Trade Amount Screen Units Updated",
	TradeAmountScreenUnitToggled = "Trade Amount Screen Amount Unit Toggled",
	TradeAmountScreenNextButtonTapped = "Trade Amount Screen Next Button Tapped",
	TradeAmountScreenAddFundsTapped = "Trade Amount Screen Add Funds Tapped",
	TradeAmountScreenFundWalletButtonTapped = "Trade Amount Screen Fund Wallet Button Tapped",
	TradeAmountScreenCloseButtonTapped = "Trade Amount Screen Close Button Tapped",
	TradeAmountScreenChipsTapped = "Trade Amount Screen Chips Tapped",
	TradeAmountScreenLeverageChipsTapped = "Trade Amount Screen Leverage Chips Tapped",
	TradePaymentMethodTapped = "Trade Payment Method Tapped",
	TradeSummaryScreenViewed = "Trade Summary Screen Viewed",
	TradeSummaryScreenDetailsExpanded = "Trade Summary Screen Details Expanded",
	TradeSummaryScreenCloseButtonTapped = "Trade Summary Screen Close Button Tapped",
	TradeCancelPurchaseCTATapped = "Trade Cancel Purchase CTA Tapped",
	TradeSummaryScreenExecutionPriceTapped = "Trade Summary Screen Execution Price Tapped",
	TradeSummaryScreenNextTapped = "Trade Summary Screen Next Tapped",
	TradeSummaryScreenMaximizeShowTermsTapped = "Trade Summary Screen Maximize Show Terms Tapped",
	TradeSummaryScreenMaximumSlippageTapped = "Trade Summary Screen Maximum Slippage Tapped",
	TradeSummaryScreenInfoButtonTapped = "Trade Summary Screen Info Button Tapped",
	TradeSuccessScreenViewed = "Trade Success Screen Viewed",
	TradeSuccessScreenCTATapped = "Trade Success Screen CTA Tapped",
	TradeSuccessScreenTaxWithheldCTATapped = "Trade Success Screen Tax Withheld CTA Tapped",
	//limit order specific
	LimitOrderDetailViewed = "Order Details Viewed",
	LimitOrderConfirmationCancel = "Order Cancellation Confirmation Clicked Cancel",
	LimitOrderDetailError = "Order Details Error Screen Viewed",
	LimitOrderDetailsFundWalletCTATapped = "Order Details Fund Wallet CTA Tapped",
	LimitOrderWidgetPillTapped = "Limit Orders home pill tapped",
	//fee transparency
	TradeSummaryFeeSectionTapped = "Trade Summary Fee Section Tapped",
	// New active trader
	NewActiveTrader = "New Active Trader"
}
